import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import DriverEarning from './DriverEarning';
import Earningreports from './Earningreports';
import { useSelector } from "react-redux";
import { PageHeader } from '../common/tableTheme';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AllReports() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', p: 0.5 }}>
      <PageHeader 
        title="Relatórios & Desempenho" 
        subtitle="Métricas operacionais, produtividade por condutor e histórico consolidado da frota."
      />
      <Box sx={{ 
        bgcolor: '#f1f5f9', 
        p: 0.5, 
        borderRadius: '12px', 
        display: 'inline-flex',
        border: '1px solid #e2e8f0',
        mb: 2.5
      }}>
        <Tabs 
          value={value} 
          onChange={handleChange} 
          TabIndicatorProps={{ style: { display: 'none' } }}
          sx={{
            minHeight: '36px',
            '& .MuiTab-root': {
              minHeight: '36px',
              py: 0.75,
              px: 2,
              borderRadius: '8px',
              fontSize: '0.8125rem',
              fontWeight: 600,
              textTransform: 'none',
              color: '#64748b',
              transition: 'all 0.15s ease',
              '&.Mui-selected': {
                color: '#ffffff',
                bgcolor: '#0f172a',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }
            }
          }}
        >
          {auth.profile.usertype === "fleetadmin" || auth.profile.usertype === "admin" ?
            <Tab label="Produtividade por Condutor" {...a11yProps(0)} />
          :null}
          {auth.profile.usertype === "admin" ?
            <Tab label="Consolidado de Operação" {...a11yProps(1)} />
          :null}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <DriverEarning/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Earningreports/>
      </TabPanel>
    </Box>
  );
}